import { DataFetchingClient, DataFetchingClientProvider, useDataFetchingClient } from 'data-fetching-client';
import { jsx as _jsx } from "react/jsx-runtime";
const fallbackClient = new DataFetchingClient();
export function OptionalDFCProvider({
  children
}) {
  var _useDataFetchingClien;
  const client = (_useDataFetchingClien = useDataFetchingClient(false)) !== null && _useDataFetchingClien !== void 0 ? _useDataFetchingClien : fallbackClient;
  return /*#__PURE__*/_jsx(DataFetchingClientProvider, {
    client: client,
    children: children
  });
}